module.exports = __webpack_public_path__ + "img/crystal.18edf181.png";